/** Expand Search box when icon is clicked */
const searchBarController = () => {
    let init = () => {
        document.addEventListener('click', function (event) {
            if(!event.target.matches('.search-box .search-box-button')){
                return
            }
            toggleSearch()
        }, false)
    }
    let toggleSearch = () => {
        let searchInput = document.querySelector('#search-box-input')
        if (searchInput) searchInput.classList.toggle('active')
        let mobiSearchInput = document.querySelector('#mobi-search-box-input')
        if (mobiSearchInput) mobiSearchInput.classList.toggle('active')
    }
    init();
    //
}

searchBarController();
